import { getFormattedPhoneNumber } from '@liveauctioneers/caterwaul-components/lib/Forms/PhoneForm/utils/phoneForm';
import Link from '@liveauctioneers/caterwaul-components/lib/Link/Link';
import { PencilSimple } from '@liveauctioneers/hammer-ui-core/icons';

import { useAppSelector } from '@/redux/hooks';
import { getBidderPhoneNumber } from '@/redux/modules/account/user/user.selectors';
import { getProfileUrl } from '@/utils/urls';

const EditPhoneNumber = () => {
    const phoneNumberString = useAppSelector(getBidderPhoneNumber);
    const phoneNumber = getFormattedPhoneNumber(phoneNumberString);
    return (
        <Link
            route
            to={getProfileUrl()}
        >
            {phoneNumber}
            <PencilSimple
                className="ml-2xs inline-block"
                size="sm"
                style="bold"
            />
        </Link>
    );
};

export default EditPhoneNumber;
